import type React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '~/store/auth';

interface PrivateRouteProps {
    element: React.ReactElement;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element }) => {
    const { isAuthenticated, roles } = useAuthStore();

    if (!isAuthenticated || roles?.length === 0) {
        return <Navigate to="/" replace />;
    }

    return element;
};

export default PrivateRoute;
